import { theme } from '../theme';
const baseAlertStyles = {
    gap: theme.spaces.x16,
    fontSize: theme.fontSizes.x14,
    borderRadius: theme.radius.x12,
    fontFamily: theme.fontFamily.text,
    padding: theme.spaces.x16,
    borderColor: theme.colors.gray200,
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadows.lg,
    color: theme.colors.gray700
};
const iconVariants = {
    default: {
        backgroundColor: theme.colors.white,
        color: theme.colors.gray700,
        iconWrapperColor: theme.colors.gray600,
        modernIcon: {
            backgroundColor: theme.colors.gray100
        }
    },
    brand: {
        color: theme.colors.brand700,
        backgroundColor: theme.colors.brand50,
        iconWrapperColor: theme.colors.brand600,
        modernIcon: {
            backgroundColor: theme.colors.brand100
        }
    },
    gray: {
        color: theme.colors.gray700,
        backgroundColor: theme.colors.gray50,
        iconWrapperColor: theme.colors.gray600,
        modernIcon: {
            backgroundColor: theme.colors.gray100
        }
    },
    error: {
        color: theme.colors.error700,
        backgroundColor: theme.colors.error50,
        iconWrapperColor: theme.colors.error600,
        modernIcon: {
            backgroundColor: theme.colors.error100
        }
    },
    warning: {
        color: theme.colors.warning700,
        backgroundColor: theme.colors.warning50,
        iconWrapperColor: theme.colors.warning600,
        modernIcon: {
            backgroundColor: theme.colors.warning100
        }
    },
    success: {
        color: theme.colors.success700,
        backgroundColor: theme.colors.success50,
        iconWrapperColor: theme.colors.success600,
        modernIcon: {
            backgroundColor: theme.colors.success100
        }
    },
    info: {
        color: theme.colors.gray700,
        backgroundColor: theme.colors.gray50,
        iconWrapperColor: theme.colors.gray600,
        modernIcon: {
            backgroundColor: theme.colors.gray100
        }
    }
};
const contentStyles = {
    fontSize: theme.text.sm.fontSize,
    lineHeight: theme.text.sm.lineHeight,
    text: {
        fontWeight: theme.fontWeight.semiBold,
        color: theme.colors.gray700
    },
    supportingText: {
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.gray600
    }
};
export const tokens = {
    Alert: {
        ...baseAlertStyles,
        Icon: iconVariants,
        Content: contentStyles
    }
};
